import { render } from "./pop-up.vue?vue&type=template&id=136a951d&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-136a951d"

export default script